<template>
  <div class="InviteMenu__wrapper">
    <div class="InviteMenu__header">
      <i class="InviteMenu__header-icon"></i>
      Invite via URL
    </div>
    <div class="InviteMenu__container">
      <div v-if="!contacts.length"
           class="InviteMenu__empty-result-box">
        You have no contacts.
      </div>
      <div class="InviteMenu__user-row"
           v-for="user in contacts">
        <img class="InviteMenu__user-avatar"
             :src="user.avatarUrl"
             v-fallback-src="'../../../../static/images/default-user-avatar.jpg'"/>
        <div class="InviteMenu__user-info">
          <div class="InviteMenu__name">
            {{ user.contactName }}
          </div>
          <div class="InviteMenu__username">
            @{{ user.username }}
          </div>
        </div>
        <div class="InviteMenu__user-checkbox">
          <input
          type="checkbox"
          :id="'check_user_'+user.userId"
          v-on:change="check(user)"
          v-model="user.checked">
          <label
          class="form-value"
          :for="'check_user_'+user.userId">
            <i class="icon-ic_tick-small InviteMenu__user-checkbox-icon"></i>
            <i class="icon-ic_plus InviteMenu__user-checkbox-icon"></i>
          </label>
        </div>
      </div>
    </div>
    <div class="InviteMenu__footer">
      <div class="InviteMenu__invite-btn"
           :class="{'invalidate': !checked.length}"
           @click="submit">
        invite
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'InviteMenu',
    data() {
      return {
        checked: []
      };
    },
    computed: {
      contacts() {
        return this.$store.getters.contacts;
      }
    },
    methods: {
      check(user) {
        if (this.checked.indexOf(user.userId) >= 0) {
          this.checked.splice(this.checked.indexOf(user.userId), 1);
        } else {
          this.checked.push(user.userId);
        }
      },
      submit() {
        const credentials = this.$store.getters.conference.credentials;
        this.$store.dispatch(
          'sendInviteMessages',
          {
            users: this.checked,
            url: credentials.conferenceUrl,
            username: credentials.username,
            pin: credentials.conferencePin
          }
        );
      }
    },
    mounted() {
      this.$store.dispatch('getUserContacts');
    }
  };
</script>

<style scoped lang="scss">
  @import 'style.scss';
</style>



// WEBPACK FOOTER //
// invite-menu.vue?529c8fd7